export enum CognitoAttributes {
  Name = "name",
  FamilyName = "family_name",
  GivenName = "given_name",
  MiddleName = "middle_name",
  Nickname = "nickname",
  PreferredUsername = "preferred_username",
  Profile = "profile",
  Picture = "picture",
  Website = "website",
  Gender = "gender",
  Birthdate = "birthdate",
  Zoneinfo = "zoneinfo",
  Locale = "locale",
  UpdatedAt = "updated_at",
  Address = "address",
  Email = "email",
  DDINumber = "custom:ddi_number",
  PhoneNumber = "phone_number",
  CellNumber = "custom:cell_number",
  Sub = "sub",
  Unable = "custom:unable",
  ResponsibleDocument = "custom:responsible_document",
  ResponsibleName = "custom:responsible_name",
  TypeEntity = "custom:type_entity",
  ContactName = "custom:contact_name",
  Cnpj = "custom:cnpj",
  TipoUsuario = "custom:user_type"
}
